import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { range } from 'lodash';

import { buildSearchLink } from 'utils/search';
import { Pagination } from 'components/core/Pagination';

export default function SearchPagination({ numPages, searchParams, ...rest }) {
	const pages = useMemo(
		() =>
			range(0, numPages).map((index) => ({
				url: buildSearchLink({ ...searchParams, page: index + 1 }),
				nofollow: false,
				number: index + 1,
			})),
		[numPages, searchParams],
	);

	return (
		<Pagination
			className="search-pagination"
			pages={pages}
			{...rest}
		/>
	);
}

SearchPagination.propTypes = {
	numPages: PropTypes.number,
	searchParams: PropTypes.object,
};
